import { render } from "./NewVisitPanel.vue?vue&type=template&id=2bffd6f1&scoped=true"
import script from "./NewVisitPanel.vue?vue&type=script&lang=js"
export * from "./NewVisitPanel.vue?vue&type=script&lang=js"

import "./NewVisitPanel.vue?vue&type=style&index=0&id=2bffd6f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bffd6f1"]])

export default __exports__